import LoggingService from './LoggingService';

export default new LoggingService();
